import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export default function ManualPaymentApprovalCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells');
    const onClick = ()=>onOpenModal({
            width: '500px',
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.draft.manualPaymentApproval(),
                    testId: "edit-manual-payment-approval-modal-".concat(index),
                    content: /*#__PURE__*/ _jsx(Checkbox, {
                        testId: "edit-manual-payment-approval-checkbox-".concat(index),
                        checked: draft.allowManualPayments(),
                        onChange: ()=>setDraft(draft.setAllowManualPayments(!draft.allowManualPayments())),
                        bi: {
                            name: 'allow_manual_payment_approval'
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            skin: "standard",
                            children: draftCellsTexts.shared.letClientManuallyApprove()
                        })
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-manual-payment-approval-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "manual-payment-approval-".concat(index),
            children: draft.allowManualPayments() ? 'Yes' : 'No'
        })
    });
}
